import React from 'react';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import MileageFirstRegister from '@di-shared/features/mileage/first-register/MileageFirstRegister';

interface MileageFirstRegisterPageProps {
  vin: string;
}

function MileageFirstRegisterPage({vin}: MileageFirstRegisterPageProps) {
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <MileageFirstRegister vin={vin} />
    </div>
  );
}

export default MileageFirstRegisterPage;
